import React from "react";

export function Modal({ title, onClose, children, wide, resizable }) {
  const [size, setSize] = React.useState({ w: wide ? 900 : 520, h: null });
  const [isResizing, setIsResizing] = React.useState(false);
  const startResize = React.useCallback((e) => {
    e.preventDefault();
    const startX = e.clientX, startY = e.clientY;
    const startW = size.w;
    const startH = size.h || 600;
    const onMove = (me) => {
      setSize({ w: Math.max(380, startW + me.clientX - startX), h: Math.max(300, startH + me.clientY - startY) });
    };
    const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); setIsResizing(false); };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    setIsResizing(true);
  }, [size]);
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50" style={{ background: "rgba(0,0,0,0.35)" }}>
      <div className="bg-white rounded-xl shadow-2xl p-6 mx-4 overflow-y-auto relative"
        style={{ width: size.w, maxWidth: "98vw", height: size.h || undefined, maxHeight: size.h ? undefined : "92vh", minWidth: 320, minHeight: 200, userSelect: isResizing ? 'none' : undefined }}>
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-bold text-lg text-gray-800">{title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-2xl leading-none">×</button>
        </div>
        {children}
        <div onMouseDown={startResize} style={{ position: 'absolute', bottom: 0, right: 0, width: 18, height: 18, cursor: 'nwse-resize', zIndex: 10, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', padding: 3 }}>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M9 1L1 9M9 5L5 9M9 9L9 9" stroke="#ccc" strokeWidth="1.5" strokeLinecap="round"/></svg>
        </div>
      </div>
    </div>
  );
}
